import {
  InputUserVerificationSearch,
  UserVerificationStatus,
} from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import store from "@/store";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";

export default function useUserVerification() {
  const { authUserStrict } = useAuthUser();

  const search = async (data: InputUserVerificationSearch) => {
    return providers.UserVerificationProvider.search({ data });
  };
  const start = async (userId: string) => {
    return providers.UserVerificationProvider.start(userId);
  };
  const startUpgradeStatus = async (userId: string) => {
    return providers.UserVerificationProvider.startUpgradeStatus(userId);
  };

  const approved = async (userId: string): Promise<boolean> => {
    try {
      const { result } = await search({ userIds: [userId] });
      const data = result.find(i => i.userId === userId);
      return data?.status !== UserVerificationStatus.UNVERIFIED ?? false;
    } catch (e) {
      return false;
    }
  };

  const findMyStatus = async () => {
    const dataVerification = await search({ userIds: [authUserStrict.value.id] });
    const dataVerified = dataVerification.result.find(i => i.userId === authUserStrict.value.id) ?? null;
    store.commit(MUTATION_TYPES.SET_USER_VERIFICATION, dataVerified);
    return dataVerified;
  };

  return {
    search,
    start,
    startUpgradeStatus,
    approved,
    findMyStatus,
  };
}
